import { makeStyles } from '@material-ui/core/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  itemDatesAside: {
    minWidth: '11.5rem',
    display: 'flex',
    gap: '0.75rem',
  },
  label: {
    fontSize: '0.75rem',
    lineHeight: '1rem',
    color: neutral['60'],
  },
  date: {
    fontSize: '0.75rem',
    fontWeight: 'bold',
    lineHeight: '1.25rem',
    color: neutral['100'],
    '@media screen and (width >= 768px)': {
      fontSize: '1rem',
    },
  },
});
